import { atom } from 'jotai';
import { getUser } from 'utils/js/user';

export const user = atom(getUser());
